<template>
  <a-card :bordered="false" style="border-left:2px solid #3BA1EB;margin-left: -2px;">
    <h1 style="text-align: center;margin-bottom: 0px">项目履约情况</h1>
    <div style="margin-bottom: 40px">
      <a-button  type="primary" style="float:right;" @click="showAdd">新增</a-button>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <div slot="action" slot-scope="text, record">
          <a-button  @click="check(record)">查看</a-button>
        </div>
      </a-table>
    </div>

    <a-modal style="padding: 0" width='1000px' v-model="visible" title="录入履约情况内容"  :dialog-style="{ top: '20px' }" :maskClosable="false">
        <div>
          <a-form :form="form">
            <a-form-item labelAlign="left"
                         :labelCol="{span:2}"
                         :wrapperCol="{span:10}"
                         label="标题" required
                         style="width: 800px"
            >
              <a-input :disabled='noInput' placeholder="请输入标题" v-decorator="['performanceTitle',{rules:[{ required:true,message: '请输入标题'}]}]"/>
            </a-form-item>
            <a-form-item  label="履约内容" labelAlign="left" :labelCol="{span:3}" :wrapperCol="{span:24}" style="min-height: 300px" required>
              <JEditor :disabled='noInput' v-model="jeditor.value" id="editorCentent"></JEditor>
            </a-form-item>
          </a-form>
        </div>
        <div style="margin-top: 10px" v-show="!noInput">
          <a-upload
            name="file"
            :action="uploadAction"
            :headers="tokenHeader"
            accept=".zip, .rar,"
            :beforeUpload="beforeUpload"
            :showUploadList="false"
            @change="handleChange">
            <a-button >
              <a-icon type="upload"/>
              上传附件
            </a-button>
          </a-upload>
        </div>
        <div style="margin-left:10px;margin-top: 10px;" v-show="performanceFileUrl && performanceFileUrl.length>0 && !noInput" >{{performanceFileName}}&nbsp;&nbsp;&nbsp;&nbsp; <a :href="performanceFileUrl" target="_blank">[下载]</a> &nbsp;&nbsp;&nbsp;&nbsp; <a @click="deleteFile">[删除]</a></div>
        <div style="margin-left:10px;margin-top: 10px;" v-show="performanceFileUrl && performanceFileUrl.length>0 && noInput">附件：<a :href="performanceFileUrl" target="_blank">{{performanceFileName}}</a> &nbsp;&nbsp;&nbsp;&nbsp;</div>
      <template slot="footer" >
        <a-button  @click="close">关闭</a-button>
        <a-button type="primary"  @click="submitForm" v-show="!noInput">确定</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import {getAction,postAction} from "@api/manage"
import JEditor from '@/components/fzis/JEditor'
import upload from "@comp/upload"
import { FzisListMixin } from '@/mixins/FzisListMixin'
import {mapGetters} from "vuex";

export default {
  name: "Performance",
  components:{
    JEditor,
    upload,
  },
  mixins: [FzisListMixin],
  computed: {
    ...mapGetters(['username', 'nickname', 'userInfo']),
    uploadAction() {
      return window._CONFIG['domianURL']+"/sys/common/upload";
    },
    roleCode: function() {
      return this.userInfo.roleCode;
    },
  },
  data(){
    return{
      bidProjectId:"",
      queryParam: {},
      columns:[
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '标题',
          width: 150,
          align: "center",
          dataIndex: 'performanceTitle'
        },
        {
          title: '录入时间',
          width: 150,
          align: "center",
          dataIndex: 'performanceEnterTime'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'action',
          align: "center",
          scopedSlots: { customRender: 'action' }
        },
      ],
      visible: false,
      noInput: false,
      jeditor: {
        value: ''
      },
      folder:[],
      form: this.$form.createForm(this),
      url: {
        list:"/ebid-ce/tmPerformance/list",
        minioUpload: "/ebid-ce/file/upload",
      },
      performanceFileUrl:"",
      performanceFileName:"",
    }
  },
  methods:{
    setBidProjectId(id) {
      this.bidProjectId = id
      getAction("/ebid-ce/tmBidProject/queryById",{id:this.bidProjectId}).then(res => {
        if(res.success){
          this.tenderProjectInfo = res.result;
        }else {
        }
      })
      this.queryParam.bidProjectId = id;
      this.loadData();
    },

    showAdd() {
      this.visible = true;
      this.noInput = false;
      this.$nextTick(() => {
        this.form.setFieldsValue({'performanceTitle':""})
      });
      this.jeditor.value = "";
      this.performanceFileUrl = ""
    },

    check(record){
      this.visible = true;
      this.noInput = true;
      getAction("/ebid-ce/tmPerformance/check",{id:record.id}).then(res => {
        if (res.success){
          this.$nextTick(() => {
            this.form.setFieldsValue({'performanceTitle':res.result.performanceTitle})
          });
          this.jeditor.value = res.result.performanceContent;
          this.performanceFileUrl = res.result.performanceFileUrl
          this.performanceFileName = res.result.performanceFileName
        }
      })
    },
    beforeUpload(file){
      let fileName = file.name;
      let pos = fileName.lastIndexOf(".");
      let lastName = fileName.substring(pos, fileName.length);
      if (
        lastName.toLowerCase() !== ".zip"&&
        lastName.toLowerCase() !== ".rar"
      ) {
        this.$message.error("文件必须为.zip .rar类型");
        return false;
      }
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.$message.success(`${info.file.name} 上传成功!`);
          this.performanceFileName=`${info.file.name}`;
          this.performanceFileUrl=`${info.file.response.message}`;
          this.fileList=`${info.file.response.message}`;
        } else {
          this.$message.error(`${info.file.response.message}`);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.response.message}`);
      }
    },
    deleteFile(){
      let that = this;
      that.$confirm({
        title: "确认删除",
        content: "是否删除附件?",
        onOk: function () {
          that.performanceFileUrl="";
          that.performanceFileName="";
        }
      });
    },
    submitForm(){
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err){
         if (that.jeditor.value.trim() != ""){
           let params = {};
           params.bidProjectId = that.bidProjectId;
           params.performanceTitle = values.performanceTitle;
           params.performanceContent = that.jeditor.value;
           params.performanceFileUrl = that.performanceFileUrl;
           postAction("/ebid-ce/tmPerformance/add",params).then((res) =>{
             if (res.success){
               this.$message.success(res.message)
               this.visible = false;
               this.loadData()
             }
           })
         }else{
           this.$message.error("履约内容不能为空")
         }
        }
      })
    },
    close(){
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>